export default __webpack_public_path__ + "static/media/badge6.5bbbfdbf.png";